import { useT } from "../../i18n";

interface ViewerPlacementBannerProps {
	widthMm: number;
	heightMm: number;
	onCancel: () => void;
}

export function ViewerPlacementBanner({
	widthMm,
	heightMm,
	onCancel,
}: ViewerPlacementBannerProps) {
	const t = useT();
	return (
		<div className="viewer-placement-banner" role="status" aria-live="polite">
			<div className="viewer-placement-banner__copy">
				<p className="viewer-placement-banner__eyebrow">
					{t.viewer_placementWindowTitle}
				</p>
				<p className="viewer-placement-banner__size">{`${widthMm} × ${heightMm} mm`}</p>
				<p className="viewer-placement-banner__hint">
					{t.viewer_placementHint}
				</p>
			</div>
			<button
				autoFocus
				type="button"
				className="viewer-placement-banner__cancel"
				onClick={onCancel}
			>
				{t.viewer_placementCancel}
			</button>
		</div>
	);
}
